import { useEffect, useState } from "react";

const NAME_LOCAL_STORAGE = "sim.t2b:";
const NAME_LOCAL_STORAGE_TEMP = "sim.t2b.temp:";

function getLocalStorageValue<T = any>(key: string, defaultValue: T):T{
  const saved = localStorage.getItem(key);
  if(saved){
    const initial:T = JSON.parse(saved);
    return initial || defaultValue;
  }
  return defaultValue;
}

function getSessionStorageValue<T = any>(key: string, defaultValue: T):T{
  const saved = sessionStorage.getItem(key);
  if(saved){
    const initial:T = JSON.parse(saved);
    return initial || defaultValue;
  }
  return defaultValue;
}

export default function useLocalStorage<T = any>(key: string, defaultValue: any){
  const [value, setValue] = useState<T>(() => {
    return getLocalStorageValue<T>(`${NAME_LOCAL_STORAGE}${key}`, defaultValue);
  });

  useEffect(() => {
    localStorage.setItem(`${NAME_LOCAL_STORAGE}${key}`, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};

function getPagePath(location:string){
  let aux = location;
  while (aux.indexOf("/") !== -1){
    aux = aux.replace("/",".");
  }
  return aux.substr(1,aux.length);
}

export function useSessionStorageTempPage<T = any>(key: string, defaultValue: T):[T, React.Dispatch<React.SetStateAction<T>>]{
  const [value, setValue] = useState<T>(() => {
    return getSessionStorageValue<T>(`${NAME_LOCAL_STORAGE_TEMP}${getPagePath(window.location.pathname)}:${key}`, defaultValue);
  });

  useEffect(() => {
    sessionStorage.setItem(`${NAME_LOCAL_STORAGE_TEMP}${getPagePath(window.location.pathname)}:${key}`, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};

export function clearTempPage(location: string){
  let i = 0;
  let key = null;
  let aux_str = `${NAME_LOCAL_STORAGE_TEMP}${getPagePath(location)}:`;
  do {
    key = sessionStorage.key(i);
    if(key && key.indexOf(aux_str) !== -1) {
      sessionStorage.removeItem(key);
    } else {
      i++;
    }
  } while (key);
}

export function setStorage<T = any>(key: string, defaultValue: T){
  localStorage.setItem(`${NAME_LOCAL_STORAGE}${key}`, JSON.stringify(defaultValue));
}

export function getStorage<T = any>(key: string):T | null{
  let res = localStorage.getItem(`${NAME_LOCAL_STORAGE}${key}`);
  if(res){
    let _return:T | null = JSON.parse(res);
    return _return;
  }
  return null;
}

export function removeStorage(key: string){
  localStorage.removeItem(`${NAME_LOCAL_STORAGE}${key}`);
}